import { createContext } from 'react';

const SurveyOptionContext = createContext<
  { disableEdit: boolean, trialHasStarted: boolean }
>({
  disableEdit: false,
  trialHasStarted: false,
}); // default value is false
export default SurveyOptionContext;
